import { OrganizationReportParameters } from '../../../../shared/model/organization-report-parameters.model';
import { OrganizationDashboardService } from '../../organization-dashboard.service';
import * as i0 from "@angular/core";
import * as i1 from "../../organization-dashboard.service";
import * as i2 from "../../../../ng-jhipster/language/jhi-translate.directive";
import * as i3 from "@fortawesome/angular-fontawesome";
import * as i4 from "@ng-bootstrap/ng-bootstrap";
import * as i5 from "@angular/common";
import * as i6 from "ngx-echarts";
const _c0 = function () { return { renderer: "svg" }; };
function WellbeingBaselineAndImpactComponent_ng_container_5_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵelement(2, "span", 11);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelement(4, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 10);
    i0.ɵɵelement(6, "span", 13);
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵelement(8, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r4.lastScanChartOption)("initOpts", i0.ɵɵpureFunction0(4, _c0));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r4.firstScanChartOption)("initOpts", i0.ɵɵpureFunction0(5, _c0));
} }
function WellbeingBaselineAndImpactComponent_ng_container_5_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelement(2, "fa-icon", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p", 16);
    i0.ɵɵelementEnd();
} }
function WellbeingBaselineAndImpactComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WellbeingBaselineAndImpactComponent_ng_container_5_div_1_Template, 9, 6, "div", 7);
    i0.ɵɵtemplate(2, WellbeingBaselineAndImpactComponent_ng_container_5_div_2_Template, 4, 0, "div", 8);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.notEnoughData);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.notEnoughData);
} }
function WellbeingBaselineAndImpactComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "p", 18);
    i0.ɵɵelementEnd();
} }
export class WellbeingBaselineAndImpactComponent {
    constructor(organizationDashboardService) {
        this.organizationDashboardService = organizationDashboardService;
        this.windowWidth = window.innerWidth;
        this.isLoadingData = false;
        this.leftGrid = '105';
        this.rightGrid = '20';
        this.console = console;
    }
    set parameters(value) {
        this._parameters = value;
        this.loadReport();
    }
    get parameters() {
        return this._parameters;
    }
    ngOnInit() { }
    loadReport() {
        this.isLoadingData = true;
        this.organizationDashboardService.getOrganizationSrqImpactPercentageReport(this.parameters).subscribe(response => {
            this.report = response.body;
            this.report.departments = this.report.departments.filter(d => d === 'Company total' || d === 'EU Benchmark');
            this.report.lastScans = this.report.lastScans.filter(ls => ls.department === 'Company total' || ls.department === 'EU Benchmark');
            this.report.firstScans = this.report.firstScans.filter(fs => fs.department === 'Company total' || fs.department === 'EU Benchmark');
            this.report.changes = this.report.changes.filter(c => c.department === 'Company total' || c.department === 'EU Benchmark');
            console.log(this.report);
            this.refreshChartData();
            this.isLoadingData = false;
            this.notEnoughData = false;
        }, error => {
            console.log(error);
            if (error.error.title === 'NotEnoughDataForOrganizationReport') {
                this.notEnoughData = true;
            }
            this.isLoadingData = false;
        });
    }
    refreshChartData() {
        var _a, _b, _c;
        const dataset = [];
        if ((_a = this.report) === null || _a === void 0 ? void 0 : _a.firstScans) {
            for (const reportItem of this.report.firstScans) {
                dataset.unshift([
                    reportItem.department,
                    reportItem.resilientUsersPercentage,
                    reportItem.atRiskUsersPercentage,
                    reportItem.inAToughPlaceUsersPercentage,
                ]);
            }
        }
        if ((_b = this.report) === null || _b === void 0 ? void 0 : _b.lastScans) {
            for (const reportItem of this.report.lastScans) {
                dataset.unshift([
                    reportItem.department,
                    reportItem.resilientUsersPercentage,
                    reportItem.atRiskUsersPercentage,
                    reportItem.inAToughPlaceUsersPercentage,
                ]);
            }
        }
        if ((_c = this.report) === null || _c === void 0 ? void 0 : _c.changes) {
            for (const reportItem of this.report.changes) {
                dataset.unshift([
                    reportItem.department,
                    reportItem.resilientUsersPercentage,
                    reportItem.atRiskUsersPercentage,
                    reportItem.inAToughPlaceUsersPercentage,
                ]);
            }
        }
        this.firstScanChartOption = {
            tooltip: {
                valueFormatter: v => Math.round(parseFloat(v.toString())) + "%",
                trigger: 'axis',
                textStyle: {
                    color: '0A4A3A',
                    fontFamily: "'Open Sans', 'sans-serif'"
                }
            },
            legend: {
                orient: 'horizontal',
                bottom: 35,
                textStyle: {
                    color: '#0A4A3A',
                    fontFamily: "'Open Sans', 'sans-serif'"
                },
                lineStyle: {
                    width: 0
                },
                itemWidth: 15
            },
            grid: {
                top: 0,
                left: this.leftGrid,
                right: this.rightGrid,
                bottom: 20,
                height: 70
            },
            xAxis: {
                show: false,
                type: 'value',
                minInterval: 1,
                max: 100,
                splitLine: {
                    show: false
                },
                axisLabel: {
                    color: '#9DB7B0',
                    fontFamily: "'Open Sans', 'sans-serif'",
                    formatter(v) {
                        return v + "%";
                    }
                }
            },
            yAxis: {
                type: 'category',
                boundaryGap: true,
                splitLine: {
                    show: false
                },
                axisLine: {
                    show: false,
                    lineStyle: {
                        color: '#0A4A3A'
                    }
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    color: '#0A4A3A',
                    fontFamily: "'Open Sans', 'sans-serif'",
                },
                data: this.report.departments
            },
            series: [
                {
                    name: 'Tough place',
                    type: 'bar',
                    color: '#AF3B6E',
                    stack: 'total',
                    barWidth: 25,
                    label: {
                        color: 'white',
                        show: true,
                        formatter(d) {
                            return d.data > 0 ? Math.round(parseFloat(d.data.toString())) + "%" : "";
                        }
                    },
                    encode: {
                        x: 'inAToughPlaceUsersPercentage',
                        y: 'department'
                    },
                    itemStyle: {
                        borderRadius: [5, 0, 0, 5]
                    },
                    animationDuration: 3000,
                    emphasis: {
                        focus: 'series'
                    },
                    data: this.report.firstScans.map(ls => ls.inAToughPlaceUsersPercentage)
                },
                {
                    name: 'At risk',
                    type: 'bar',
                    color: '#E0CA58',
                    stack: 'total',
                    barWidth: 25,
                    label: {
                        color: 'white',
                        show: true,
                        formatter(d) {
                            return d.data > 0 ? Math.round(parseFloat(d.data.toString())) + "%" : "";
                        }
                    },
                    encode: {
                        x: 'atRiskUsersPercentage',
                        y: 'department'
                    },
                    itemStyle: {
                        borderRadius: [0, 0, 0, 0]
                    },
                    animationDuration: 3000,
                    emphasis: {
                        focus: 'series'
                    },
                    data: this.report.firstScans.map(ls => ls.atRiskUsersPercentage)
                },
                {
                    name: 'Resilient',
                    type: 'bar',
                    color: '#44A38B',
                    stack: 'total',
                    barWidth: 25,
                    label: {
                        color: 'white',
                        show: true,
                        formatter(d) {
                            return d.data > 0 ? Math.round(parseFloat(d.data.toString())) + "%" : "";
                        }
                    },
                    encode: {
                        x: 'resilientUsersPercentage',
                        y: 'department'
                    },
                    itemStyle: {
                        borderRadius: [0, 5, 5, 0]
                    },
                    animationDuration: 3000,
                    emphasis: {
                        focus: 'series'
                    },
                    data: this.report.firstScans.map(ls => ls.resilientUsersPercentage)
                },
            ],
            dataset: {
                source: dataset,
                dimensions: ['department', 'resilientUsersPercentage', 'atRiskUsersPercentage', 'inAToughPlaceUsersPercentage']
            }
        };
        this.lastScanChartOption = {
            tooltip: {
                valueFormatter: v => Math.round(parseFloat(v.toString())) + "%",
                trigger: 'axis',
                textStyle: {
                    color: '0A4A3A',
                    fontFamily: "'Open Sans', 'sans-serif'"
                }
            },
            grid: {
                top: 0,
                left: this.leftGrid,
                right: this.rightGrid,
                bottom: 0,
                height: 70
            },
            xAxis: {
                show: false,
                type: 'value',
                minInterval: 1,
                max: 100,
                splitLine: {
                    show: false
                },
                axisLabel: {
                    color: '#9DB7B0',
                    fontFamily: "'Open Sans', 'sans-serif'",
                    formatter(v) {
                        return v + "%";
                    }
                },
            },
            yAxis: {
                type: 'category',
                boundaryGap: true,
                splitLine: {
                    show: false
                },
                axisLine: {
                    show: false,
                    lineStyle: {
                        color: '#0A4A3A'
                    }
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    color: '#0A4A3A',
                    fontFamily: "'Open Sans', 'sans-serif'"
                },
                data: this.report.departments
            },
            series: [
                {
                    name: 'Tough place',
                    type: 'bar',
                    color: '#AF3B6E',
                    stack: 'total',
                    barWidth: 25,
                    label: {
                        color: 'white',
                        show: true,
                        formatter(d) {
                            return d.data > 0 ? Math.round(parseFloat(d.data.toString())) + "%" : "";
                        }
                    },
                    encode: {
                        x: 'inAToughPlaceUsersPercentage',
                        y: 'department'
                    },
                    itemStyle: {
                        borderRadius: [5, 0, 0, 5]
                    },
                    animationDuration: 3000,
                    emphasis: {
                        focus: 'series'
                    },
                    data: this.report.lastScans.map(ls => ls.inAToughPlaceUsersPercentage)
                },
                {
                    name: 'At risk',
                    type: 'bar',
                    color: '#E0CA58',
                    stack: 'total',
                    barWidth: 25,
                    label: {
                        color: 'white',
                        show: true,
                        formatter(d) {
                            return d.data > 0 ? Math.round(parseFloat(d.data.toString())) + "%" : "";
                        }
                    },
                    encode: {
                        x: 'atRiskUsersPercentage',
                        y: 'department'
                    },
                    itemStyle: {
                        borderRadius: [0, 0, 0, 0]
                    },
                    animationDuration: 3000,
                    emphasis: {
                        focus: 'series'
                    },
                    data: this.report.lastScans.map(ls => ls.atRiskUsersPercentage)
                },
                {
                    name: 'Resilient',
                    type: 'bar',
                    color: '#44A38B',
                    stack: 'total',
                    barWidth: 25,
                    label: {
                        color: 'white',
                        show: true,
                        formatter(d) {
                            return d.data > 0 ? Math.round(parseFloat(d.data.toString())) + "%" : "";
                        }
                    },
                    encode: {
                        x: 'resilientUsersPercentage',
                        y: 'department'
                    },
                    itemStyle: {
                        borderRadius: [0, 5, 5, 0]
                    },
                    animationDuration: 3000,
                    emphasis: {
                        focus: 'series'
                    },
                    data: this.report.lastScans.map(ls => ls.resilientUsersPercentage)
                },
            ],
            dataset: {
                source: dataset,
                dimensions: ['department', 'resilientUsersPercentage', 'atRiskUsersPercentage', 'inAToughPlaceUsersPercentage']
            }
        };
    }
}
WellbeingBaselineAndImpactComponent.ɵfac = function WellbeingBaselineAndImpactComponent_Factory(t) { return new (t || WellbeingBaselineAndImpactComponent)(i0.ɵɵdirectiveInject(i1.OrganizationDashboardService)); };
WellbeingBaselineAndImpactComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: WellbeingBaselineAndImpactComponent, selectors: [["wellbeing-baseline-and-impact"]], inputs: { parameters: "parameters" }, decls: 8, vars: 5, consts: [[1, "card", "dashboard-card", "p-2"], [1, "d-flex", "justify-content-start", "align-items-center"], ["jhiTranslate", "inukaNgApp.organizationAdmin.organizationSrqImpactPercentage.previewHeader", 1, "ml-2", "mt-3", "mr-2", "light-weight"], ["icon", "info-circle", 2, "cursor", "pointer", "font-size", "18px", "margin-top", "6px", 3, "ngbPopover", "closeDelay"], ["popover", "ngbPopover"], [4, "ngIf"], ["percentagePopover", ""], ["class", "e-chart-parent", 4, "ngIf"], ["class", "not-enough-data-warning d-flex flex-column justify-content-center align-items-center", 4, "ngIf"], [1, "e-chart-parent"], [1, "e-chart"], ["jhiTranslate", "inukaNgApp.organizationAdmin.organizationSrqImpactPercentage.lastScan", 1, "ml-3", "scan-header"], ["echarts", "", 2, "height", "150px", "width", "100%", 3, "options", "initOpts"], ["jhiTranslate", "inukaNgApp.organizationAdmin.organizationSrqImpactPercentage.firstScan", 1, "ml-3", "scan-header"], [1, "not-enough-data-warning", "d-flex", "flex-column", "justify-content-center", "align-items-center"], ["icon", "database", "size", "2x"], ["jhiTranslate", "inukaNgApp.organizationAdmin.notEnoughData"], [1, "mt-2"], ["jhiTranslate", "inukaNgApp.organizationAdmin.organizationSrqImpactPercentage.percentagePopover"]], template: function WellbeingBaselineAndImpactComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "h4", 2);
        i0.ɵɵelement(3, "fa-icon", 3, 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, WellbeingBaselineAndImpactComponent_ng_container_5_Template, 3, 2, "ng-container", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, WellbeingBaselineAndImpactComponent_ng_template_6_Template, 2, 0, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(4);
        const _r2 = i0.ɵɵreference(7);
        i0.ɵɵadvance(3);
        i0.ɵɵstyleProp("color", _r0.isOpen() ? "#0A4A3A" : "#9DB7B0");
        i0.ɵɵproperty("ngbPopover", _r2)("closeDelay", 1000);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isLoadingData);
    } }, directives: [i2.JhiTranslateDirective, i3.FaIconComponent, i4.NgbPopover, i5.NgIf, i6.NgxEchartsDirective], styles: [".card[_ngcontent-%COMP%]{max-height:530px;min-height:345px}.chart-card[_ngcontent-%COMP%]{background:#ecf6f3;border-radius:10px;margin:10px;padding:10px}.e-chart[_ngcontent-%COMP%]{margin:10px;height:110px;border-radius:10px;background:#ecf6f3;padding:5px}.not-enough-data-warning[_ngcontent-%COMP%]{width:100%;height:200px}.not-enough-data-warning[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:#9db7b0}.not-enough-data-warning[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-top:10px;color:var(--green-lighter)}.page-tab[_ngcontent-%COMP%]{border-radius:4px;cursor:pointer;border:1px solid #fff;color:#9db7b0;padding-left:0;padding-right:0;min-width:7rem}.page-tab-selected[_ngcontent-%COMP%]{color:#44a38b;text-decoration:underline}.grid-container[_ngcontent-%COMP%]{display:grid;grid-template-columns:repeat(1, minmax(0, 1fr));padding:10px}.resilient-circle[_ngcontent-%COMP%]{width:14px;height:14px;border-radius:25%;background:#44a38b}.at-risk-circle[_ngcontent-%COMP%]{width:14px;height:14px;border-radius:25%;background:#e0ca58}.tough-place-circle[_ngcontent-%COMP%]{width:14px;height:14px;border-radius:25%;background:#af3b6e}.legend-text[_ngcontent-%COMP%]{color:#0a4a3a;font-family:\"Open Sans\",serif;font-size:12px;font-style:normal;font-weight:400;line-height:140%}.scan-header[_ngcontent-%COMP%]{color:#9db7b0;font-feature-settings:\"clig\" off,\"liga\" off;font-family:\"Open Sans\",serif;font-size:12px;font-style:normal;font-weight:400;line-height:140%}.e-chart-parent[_ngcontent-%COMP%]{height:auto !important}@media(min-width: 992px){.grid-container[_ngcontent-%COMP%]{display:grid;grid-template-columns:repeat(2, minmax(0, 1fr));padding:10px}}@media(min-width: 1200px){.not-enough-data-warning[_ngcontent-%COMP%]{height:400px}.grid-container[_ngcontent-%COMP%]{display:grid;grid-template-columns:repeat(1, minmax(0, 1fr));padding:10px}}@media(max-width: 600px){.e-chart-parent[_ngcontent-%COMP%]{margin-bottom:20px !important}}@media(min-width: 1400px){.grid-container[_ngcontent-%COMP%]{display:grid;grid-template-columns:repeat(2, minmax(0, 1fr));padding:10px}}"] });
